export default {"src":"/_next/static/media/therapist-auth-background-mobile.025491be.svg","height":795,"width":375};